import { render, staticRenderFns } from "./poi-detail-ar.vue?vue&type=template&id=7739481e&scoped=true&"
import script from "./poi-detail-ar.vue?vue&type=script&lang=ts&"
export * from "./poi-detail-ar.vue?vue&type=script&lang=ts&"
import style0 from "./poi-detail-ar.vue?vue&type=style&index=0&id=7739481e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7739481e",
  null
  
)

export default component.exports